module.exports = "/images/Kampanj_icn.png?18c8c63b50e31c99cbc15865c253d1d5";